import { Box } from '@mui/material';
import React from 'react';
import { useOrderContext } from '../../../../context/orderContext';
import { Order } from '../../order.types';
import EmptyState from '../EmptyState';
import Loader from '../Loader';
import MultiOrderItem from '../MultiOrderItem';
import OrderItems from '../OrderItems';

interface OngoingTabProps {
  loading: boolean;
  data: Order[];
  onClickCTA: (item: Order, restaurantIds?: string[]) => void;
  onShowInfo: (item: Order) => void;
  emptyStateTitle: string;
  disabled?: boolean;
  onDamage: (item: Order, restaurantId?: string) => void;
  claimed?: boolean;
}

const TabContent: React.FC<OngoingTabProps> = ({ data, loading, emptyStateTitle, onClickCTA, onShowInfo, disabled, onDamage, claimed }) => {
  const { restaurantList, seatDataMap } = useOrderContext();

  return (
    <>
      <Box height="100%" display="flex" flexDirection="column" gap="8px">
        {loading ? (
          <Loader />
        ) : data?.length > 0 ? (
          data.map((item, index) => {
            if (item.multi_orders && item.multi_orders.length > 1) {
              return (
                <MultiOrderItem
                  key={index}
                  restaurantList={restaurantList}
                  seatDataMap={seatDataMap}
                  onClickCTA={onClickCTA}
                  onShowInfo={onShowInfo}
                  item={item}
                  disabled={disabled}
                  onDamage={onDamage}
                  claimed={claimed || false}
                />
              );
            }
            return (
              <OrderItems
                key={index}
                restaurantList={restaurantList}
                seatDataMap={seatDataMap}
                onClickCTA={onClickCTA}
                onShowInfo={onShowInfo}
                item={item}
                disabled={disabled}
                onDamage={onDamage}
              />
            );
          })
        ) : (
          <EmptyState title={emptyStateTitle} />
        )}
      </Box>
    </>
  );
};

export default TabContent;
